import styled from "styled-components";

export const StyledDotsLoaderContainer = styled.div`
    padding-left: 46px;
`;
